import React                from 'react';
import PropTypes            from 'prop-types';

import Parser               from 'html-react-parser';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                           TexteToolTip                        ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class TexteToolTip extends React.Component {

  /* ---------------------- */
  /* Affichage du composant */
  /* ---------------------- */

    render() {

        if (!this.props.texte) return null;

        /* ------------------------------- */
        /* Définition du style d'affichage */
        /* ------------------------------- */

        const encadrement = {
            border          : "1px solid black",
            padding         : "0px",
            borderSpacing   : "0px",
            display         : "inline-block"
          }
      
          const styleTexte = {
              fontFamily      : "arial, verdana, times, sans-serif",
              fontSize        : this.props.taille + "pt",
              color           : this.props.couleur,
              backgroundColor : this.props.fond,
              margin          : "0px", 
              padding         : "5px", 
              textAlign       : "center"
            }  
      
        /* ------------------- */
        /* Renvoi du composant */
        /* ------------------- */

        return (

            <div id='Encadrement' style={encadrement}>
                <div style={styleTexte}>
                    {Parser(this.props.texte)}
                </div>
            </div>

        );
    }
}

/* ------------------------------------ */
/* Définition de la structure des props */
/* ------------------------------------ */

TexteToolTip.defaultProps = {
    texte   : '',
    taille  : 11,
    couleur : '#000000',
    fond    : '#C0C0FF'
}
  
TexteToolTip.propTypes = {
    texte   : PropTypes.string,
    taille  : PropTypes.number,
    couleur : PropTypes.string,
    fond    : PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/commun/TexteToolTip.js